import { FieldArrayWithId } from 'react-hook-form';

export const findIndexFromFieldsArray = (
  fieldId: number | string | undefined,
  fields: FieldArrayWithId[],
  idProperty = 'id'
) => fields.findIndex((elem) => elem[idProperty] === fieldId);
